/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1Card.vue?vue&type=template&id=250e0881&scoped=true"
import script from "./n1Card.vue?vue&type=script&lang=js"
export * from "./n1Card.vue?vue&type=script&lang=js"
import style0 from "./n1Card.vue?vue&type=style&index=0&id=250e0881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e0881",
  null
  
)

export default component.exports